import axios from 'client';
import * as dto from 'client/dto';

function getRiskFeed(
  model: dto.RiskFeedRequestModel,
  client = axios
): Promise<dto.RiskFeedEntryModel[]> {
  return client.post('/api/riskfeed', model).then(({ data }) => data);
}

function getRiskIncidence(
  model: { diseaseId: number; locationId: number; startDate: string },
  client = axios
): Promise<dto.RiskFeedIncidenceModel> {
  const { diseaseId, locationId, startDate } = model;
  return client
    .get('/api/riskfeed/incidence', {
      params: { diseaseId, locationId, startDate },
    })
    .then(({ data }) => data);
}

export default {
  getRiskFeed,
  getRiskIncidence,
};
